import React, { useRef, useState, memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import useOutsideClick from 'hooks/useOutsideClick';
import PaymentFilterForm from './PaymentFilterForm';

const PaymentFilter = ({
  _isOpen,
  onSubmit,
  statusFilter,
  defaultValues,
  schema,
  reasonFilter,
  fieldNames,
}) => {
  const [isOpen, setIsOpen] = useState(_isOpen);
  const _onSubmit = (data) => {
    setIsOpen(false);
    return onSubmit(data);
  };

  const ref = useRef();

  useOutsideClick(ref, () => {
    if (!isOpen) return;
    if (isOpen) {
      setIsOpen(false);
    }
  });

  return (
    <div className="md:w-48 w-auto relative flex-shrink-0 z-10" ref={ref}>
      <div
        className="h-10 rounded border border-javelin-inputBorder p-3 flex flex-row justify-between items-center text-javelin-placeholder"
        onClick={() => setIsOpen(!isOpen)}
        data-testid="control"
      >
        <span className="text-sm cursor-default">Filter</span>
        <span className="w-10 h-full opacity-50 hover:opacity-100">
          <FontAwesomeIcon
            icon="chevron-down"
            pull="right"
            className="fill-current"
            size="sm"
          />
        </span>
      </div>
      {isOpen && (
        <PaymentFilterForm
          onSubmit={_onSubmit}
          reasonFilter={reasonFilter}
          statusFilter={statusFilter}
          defaultValues={defaultValues}
          schema={schema}
          fieldNames={fieldNames}
        />
      )}
    </div>
  );
};

PaymentFilter.propTypes = {
  _isOpen: PropTypes.bool,
  onSubmit: PropTypes.func,
  statusFilter: PropTypes.arrayOf(PropTypes.shape({})),
  reasonFilter: PropTypes.arrayOf(PropTypes.shape({})),
  fieldNames: PropTypes.shape({
    statusCheckbox: PropTypes.string,
    amountCheckbox: PropTypes.string,
    reasonCheckbox: PropTypes.string,
    fraudCheckbox: PropTypes.string,
  }),
};
PaymentFilter.defaultProps = {
  _isOpen: false,
  statusFilter: [],
  reasonFilter: [],
  fieldNames: {},
};

export default memo(PaymentFilter);
